import {useEffect, useRef} from 'react';

// Capture two-finger gestures before swipe navigation; keep one-finger scrolling native.
export default function usePinchZoom(ref, zooms, setZoom) {
  const current = useRef({zooms, setZoom});
  current.current = {zooms, setZoom};
  useEffect(() => {
    const element = ref.current;
    if (!element) return;
    let gesture = null;
    const scopeAt = target => target.closest?.('[data-zoom-scope]')?.dataset.zoomScope || 'app';
    const distance = touches => Math.hypot(touches[0].clientX - touches[1].clientX, touches[0].clientY - touches[1].clientY);
    const start = event => {
      if (event.touches.length !== 2) {
        if (gesture) { event.preventDefault(); event.stopPropagation(); }
        return;
      }
      const scope = scopeAt(event.target);
      gesture = {scope, distance: distance(event.touches), zoom: current.current.zooms[scope]};
      event.preventDefault();
      event.stopPropagation();
    };
    const move = event => {
      if (!gesture) return;
      event.preventDefault();
      event.stopPropagation();
      if (event.touches.length === 2 && gesture.distance > 0) current.current.setZoom(gesture.scope, gesture.zoom * distance(event.touches) / gesture.distance);
    };
    const end = event => {
      if (!gesture) return;
      event.stopPropagation();
      if (event.touches.length === 0) gesture = null;
    };
    const wheel = event => {
      if (!event.ctrlKey) return;
      event.preventDefault();
      event.stopPropagation();
      current.current.setZoom(scopeAt(event.target), value => value * Math.exp(-event.deltaY * 0.01));
    };
    const options = {passive: false, capture: true};
    element.addEventListener('touchstart', start, options);
    element.addEventListener('touchmove', move, options);
    element.addEventListener('touchend', end, options);
    element.addEventListener('touchcancel', end, options);
    element.addEventListener('wheel', wheel, options);
    return () => {
      element.removeEventListener('touchstart', start, options);
      element.removeEventListener('touchmove', move, options);
      element.removeEventListener('touchend', end, options);
      element.removeEventListener('touchcancel', end, options);
      element.removeEventListener('wheel', wheel, options);
    };
  }, [ref]);
}
